export enum ViewMode {
    horizontal = 'horizontal',
    vertical = 'vertical',
}

export enum ItemVariant {
    default = 'default',
    iconOnly = 'icon-only',
    labelOnly = 'label-only',
}

/**
 * How a closed section or popover renders.
 * 'unmount' removes the content from the DOM. 'hide' keeps the content in the DOM but hides it.
 * The values match the `closeMode` prop of the lumx `Popover` component.
 */
export type CloseMode = 'unmount' | 'hide';
